import { PageHeader, Panel } from "@/components/layout/AppShell";
import NewsList from "@/components/NewsList";
import { usePoll } from "@/context/AuthContext";
import { fmt, compact, scoreColor } from "@/lib/format";

export function NewsPage() {
  return (
    <div data-testid="news-page">
      <PageHeader eyebrow="Live" title="Market News" sub="Headlines from Moneycontrol, Economic Times, Mint and Business Standard with a quick impact tag. Refreshes every minute." />
      <Panel><NewsList /></Panel>
    </div>
  );
}

export function LiquidOptionsPage() {
  const { data } = usePoll("/liquid-options", 4000);
  return (
    <div data-testid="liquid-options-page">
      <PageHeader eyebrow="F&O Stocks" title="High Liquidity Options" sub="Most liquid stock option chains ranked by traded volume and depth, with ATM premiums, OI and PCR." />
      <Panel className="overflow-x-auto rx-scroll">
        <table className="w-full text-sm min-w-[900px]" data-testid="liquid-options-table">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-wider text-gray-500 border-b border-white/5">
              {["Stock", "LTP", "ATM", "CE", "PE", "CE OI", "PE OI", "PCR", "IV", "Volume", "Liquidity", "Strength"].map((h) => <th key={h} className="py-2 px-2 font-bold">{h}</th>)}
            </tr>
          </thead>
          <tbody className="font-data">
            {(data?.items || []).map((r) => (
              <tr key={r.symbol} className="border-b border-white/5 hover:bg-white/5 transition-colors" data-testid={`liquid-row-${r.symbol}`}>
                <td className="py-2.5 px-2 font-sans font-semibold">{r.symbol}<div className="text-[10px] text-gray-500 font-normal">Lot {r.lot}</div></td>
                <td className="px-2">{fmt(r.ltp)}</td><td className="px-2">{r.atm}</td>
                <td className="px-2 text-[#00FF66]">{fmt(r.ce)}</td><td className="px-2 text-[#FF3366]">{fmt(r.pe)}</td>
                <td className="px-2">{compact(r.ce_oi)}</td><td className="px-2">{compact(r.pe_oi)}</td>
                <td className="px-2">{r.pcr}</td><td className="px-2">{r.iv}%</td><td className="px-2">{compact(r.volume)}</td>
                <td className="px-2"><div className="flex items-center gap-2"><div className="h-1.5 w-16 bg-white/5 rounded-full"><div className="h-full rounded-full bg-[#007AFF]" style={{ width: `${r.liquidity}%` }} /></div>{r.liquidity}</div></td>
                <td className="px-2 font-bold" style={{ color: scoreColor(r.score) }}>{r.score.toFixed(0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!data && <div className="h-40 animate-pulse" />}
      </Panel>
    </div>
  );
}
